import {
    // FILE_UPLOAD,
    CREATE_SJFMEETINGS,
    RETRIEVE_SJFMEETINGS,
    UPDATE_SJFMEETINGS,
    DELETE_SJFMEETINGS,
    RETRIEVESINGLE_SJFMEETINGS,
} from "./type";
import SJFMeetings from "../service/sjfMeetings";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await SJFMeetings.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await SJFMeetings.create(data);
        dispatch({
            type: CREATE_SJFMEETINGS,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await SJFMeetings.fetchList(data);
        dispatch({
            type: RETRIEVE_SJFMEETINGS,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await SJFMeetings.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_SJFMEETINGS,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await SJFMeetings.update(data);
        dispatch({
            type: UPDATE_SJFMEETINGS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await SJFMeetings.changeStatus(data);
//         dispatch({
//             type: UPDATE_SJFMEETINGS,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await SJFMeetings.trash(data);
        dispatch({
            type: DELETE_SJFMEETINGS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};